import { formatAddressEllipsis } from '../../../../util/formatAddressEllipsis'
import { txType } from '../../types'
import { chainsDataType, networkType, networksData } from '../../../../util/chainsData'

export default function getTransactionsDataModel(
  filteredTransactions: txType[],
  chain: keyof chainsDataType,
  network: networkType,
) {
  return {
    columns: [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        width: 160,
        valueFormatter: ({ value }: { value: string }) => formatAddressEllipsis(value),
      },
      {
        field: 'receiver',
        headerName: 'Receiver Address',
        hide: true,
        width: 160,
        valueFormatter: ({ value }: { value: string }) => formatAddressEllipsis(value),
      },
      {
        field: 'amount',
        headerName: 'Amount',
        hide: true,
        width: 100,
        valueFormatter: ({ value }: { value: number }) => new Intl.NumberFormat().format(value),
      },
      {
        field: 'status',
        headerName: 'Status',
        hide: true,
        width: 130,
        renderCell: (params: any) => (
          <span className="status-container">
            <span className={`status ${params.value}`}>{params.value}</span>
          </span>
        ),
      },
      {
        field: 'createdAt',
        headerName: 'Created At',
        hide: true,
        width: 200,
        valueFormatter: ({ value }: { value: number }) =>
          new Intl.DateTimeFormat('default', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour12: false,
          }).format(new Date(value)),
      },
      {
        field: 'updatedAt',
        headerName: 'Updated At',
        hide: true,
        width: 200,
        valueFormatter: ({ value }: { value: number | null }) =>
          value
            ? new Intl.DateTimeFormat('default', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: 'UTC',
                timeZoneName: 'short',
                hour12: false,
              }).format(new Date(value))
            : '',
      },
      // {
      //   field: "completedAt",
      //   headerName: "Completed At",
      //   hide: true,
      //   width: 200,
      //   valueFormatter: ({ value }: { value: number | null }) =>
      //     value
      //       ? new Intl.DateTimeFormat("default", {
      //           year: "numeric",
      //           month: "short",
      //           day: "numeric",
      //           hour: "2-digit",
      //           minute: "2-digit",
      //           timeZone: "UTC",
      //           timeZoneName: "short",
      //           hour12: false,
      //         }).format(new Date(value))
      //       : "",
      // },
      {
        field: 'tx',
        headerName: 'Hash',
        hide: true,
        width: 160,
        renderCell: (params: any) => (
          <a
            href={networksData?.[chain]?.[network]?.explorerUrl + params.value}
            target="_blank"
            className="txHash-link"
            onClick={(e) => e.stopPropagation()}
            rel="noreferrer">
            <span className="selectableHash-container">
              <span className="selectable-value">{params.value}</span>
              <span className="select-none">{formatAddressEllipsis(params.value)}</span>
            </span>
          </a>
        ),
      },
    ],
    initialState: {
      columns: {
        columnVisibilityModel: {
          id: false,
          receiver: true,
          amount: true,
          status: true,
          reason: true,
          initiator: true,
          createdAt: true,
          updatedAt: true,
          deadline: true,
          completedAt: true,
          hash: true,
        },
      },
    },
    rows: filteredTransactions,
  }
}
